export default __webpack_public_path__ + "static/media/active.69e6078c.svg";